import { t } from "@redotech/redo-i18n";
import { Condition } from "@redotech/redo-return-core-common/return-flow/condition";
import { CONDITION_NAMES } from "@redotech/redo-return-core-common/return-flow/condition-names";
import {
  productAvailableFromModel,
  validateProductAvailableCondition,
  type ProductAvailableState,
} from "@redotech/redo-return-core-common/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export const PRODUCT_AVAILABLE = (
  Details: React.ComponentType<
    ConditionTypeDetailsProps<ProductAvailableState>
  >,
): ConditionType<ProductAvailableState, Condition.ProductAvailable> => ({
  name: CONDITION_NAMES[Condition.PRODUCT_AVAILABLE],
  description() {
    return t(
      "The item's product still exists on your store and its variant is in stock, so a same-item exchange is possible. False when the product was deleted, archived, unpublished, or is out of stock per your exchange inventory settings",
    );
  },
  Details(props: ConditionTypeDetailsProps<ProductAvailableState>) {
    return React.createElement(Details, props);
  },
  empty: {},
  fromModel(model) {
    return productAvailableFromModel(model);
  },
  toModel() {
    return { type: Condition.PRODUCT_AVAILABLE };
  },
  valid(state) {
    return validateProductAvailableCondition(state).valid;
  },
});
